module.exports = __webpack_public_path__ + "img/icon_4_20.67f6a372.png";